module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"favorites":"Favorites"},"fr":{"favorites":"Favoris"},"de":{"favorites":"Favoriten"}}')
  delete Component.options._Ctor
}
